import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import Typography from 'components/Typography'

import constants from './constants'

import classes from './Attribute.module.scss'

export const { VARIANTS } = constants

const VARIANT_ICON = {
  [VARIANTS.check]: 'check',
  [VARIANTS.uncheck]: 'times',
  [VARIANTS.unknown]: 'question',
  [VARIANTS.crown]: 'crown',
  [VARIANTS.since]: 'since',
}

const DEFAULT_ATTRIBUTE_VARIANT = VARIANTS.check

/** @type {import("./types").default} */
const Attribute = ({
  gridSize,
  isBold = false,
  label = '',
  tooltipLabel,
  tooltipIcon,
  text,
  variant = DEFAULT_ATTRIBUTE_VARIANT,
}) => {
  const isUnknown = variant === VARIANTS.unknown
  const isCrowned = variant === VARIANTS.crown
  const isSince = variant === VARIANTS.since
  const isNone = variant === VARIANTS.none
  const showNeutralStyle = !isNone && !isCrowned && variant !== VARIANTS.check
  const showRightIcon = !isSince && !isNone && !isCrowned
  const isLastReview = label === 'Last review'

  return (
    <li
      className={clsx('Attribute', classes.listItem, {
        [classes.listItemNeutral]: showNeutralStyle,
        [classes.listItemSince]: isSince,
        [classes.listLastReview]: isLastReview,
      })}
    >
      {tooltipLabel ? (
        <Tooltip className={classes.tooltip} title={tooltipLabel}>
          <Typography
            component="span"
            data-testid="security-tooltip-text"
            className={clsx(classes.listItemLabel, classes.pointer, classes[`listItemLabel-size-${gridSize}`], {
              [classes.listItemLabelSince]: isSince,
              [classes.listItemBold]: isBold,
              [classes.listItemCrowned]: isCrowned,
            })}
          >
            {label}
          </Typography>
        </Tooltip>
      ) : (
        <Typography
          component="span"
          className={clsx(classes.listItemLabel, classes[`listItemLabel-size-${gridSize}`], {
            [classes.listItemLabelSince]: isSince,
            [classes.listItemBold]: isBold,
          })}
        >
          {label}
        </Typography>
      )}
      {showRightIcon &&
        (isUnknown ? (
          <Tooltip data-testid="security-tooltip-icon" title={tooltipIcon || ''}>
            <div className={clsx(classes.listItemRight, classes.listItemIcon, classes.listItemIconNeutral)}>
              <Icon icon={VARIANT_ICON[VARIANTS[variant]]} />
            </div>
          </Tooltip>
        ) : (
          <Icon
            className={clsx(classes.listItemRight, classes.listItemIcon, {
              [classes.listItemIconNeutral]: showNeutralStyle,
            })}
            icon={VARIANT_ICON[VARIANTS[variant]]}
          />
        ))}

      {text && (
        <Typography
          component="span"
          className={clsx(classes.listItemText, classes.columnListItemText, {
            [classes.listItemRightSince]: isSince,
            [classes.listItemCrowned]: isCrowned,
            [classes.listItemBold]: isBold,
          })}
        >
          {isCrowned && (
            <Icon
              className={clsx(classes.listItemIcon, classes.listItemIconCrowned)}
              icon={VARIANT_ICON[VARIANTS[variant]]}
              size="12"
            />
          )}
          {text}
        </Typography>
      )}
    </li>
  )
}

export default Attribute
